import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { summaryEntriesSelector } from '@/domain/journal';
import JETable from '@/components/Tables/grid/JETable';
import { getMetaRange } from '@/components/Tables/helpers';
import { getDataCell } from '@/components/Tables/layout/helpers';
import { renderColgroup } from '@/components/Tables/layout/component';
import { SummaryTableLayout } from '@/components/Tables/layout/JESummaryTable/StyledComponents';
import { JETableOverride } from '@/components/Tables/layout/JEManualSummaryTable/StyledComponents';

class JEManualSummaryTable extends React.Component {
  get meta() {
    const meta = getMetaRange(this.props.data);
    return [['A', 'B', 'C', 'D', 'E'], meta[1]];
  }

  getItem = (row, col) => this.props.getItem(getDataCell(this.props.data, row, col));

  colgroup = () => {
    return renderColgroup([{ id: 'A', span: 5 }]);
  };

  render() {
    return (
      <SummaryTableLayout>
        <JETableOverride>
          <JETable meta={this.meta} getCellStyle={this.getCellStyle} getItem={this.getItem} colgroup={this.colgroup} />
        </JETableOverride>
      </SummaryTableLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  data: summaryEntriesSelector(state),
});

export default compose(connect(mapStateToProps))(JEManualSummaryTable);
